export default __webpack_public_path__ + "static/media/409.e83bb06c.png";